'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _EllipsisOutlined = _interopRequireDefault(require('./lib/icons/EllipsisOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _EllipsisOutlined;
exports.default = _default;
module.exports = _default;